<!-- クレカ情報 -->
<template>
  <div class="row">
    <div class="th cell">決済方法</div>
    <div class="cell">{{ paymentMethod }}</div>
  </div>
</template>

<script>
export default {
  name: "StoreSelectedPaymentMethod",
  props: {
    paymentMethod: {
      type: String,
      required: false,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.block {
  display: table;
  font-size: 13px;
}
.row {
  display: table-row;
}

.cell {
  font-weight: bold;
  display: table-cell;
  padding: 8px;
}
.th {
  font-weight: 100;
  padding-right: 14px;
  color: grey;
  padding-right: 14px;
}
.arrow {
  width: 10px;
  height: auto;
  padding: 0 6px 1px 6px;
}
</style>
